
class SmoothScroll {

    constructor() {
        this.smoothScrollAnchors = $('.smooth-scroll');

        if (this.smoothScrollAnchors) {
            this.smoothScrollAnchors.on('click', e => this.scrollToElement(e));
        }
    }

    scrollToElement(e) {
        e.preventDefault();

        var href = $(e.currentTarget).attr('href');
        var target = $(href);

        if (target) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 700);
        }
    }

}


export default SmoothScroll;